import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useRepassesSetoriaisState } from "../context/repasses-setoriais-context";
import { useRepassesSetoriaisController } from "../context/repasses-setoriais-controller";
import { RepasseSetorialForm } from "./repasse-setorial-form";

export const RepasseSetorialDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useRepassesSetoriaisController();
    const { dataResponse, showAddEdit } = useRepassesSetoriaisState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Repasse Setorial ${dataResponse?.id}`;
        return "Adicionar Repasse Setorial";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <RepasseSetorialForm />
        </DefaultDrawer>
    );
};
